import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocalKey, setReturnURL } from '../../../utils/commonfunction';
import { STAFF_ROLE } from "../../../utils/Constants";
import { useSelector } from 'react-redux';
import { selectRoutes, selectRole } from '../../../redux/slices/authSlice';
import NoPermission from '../common/noPermission';

const PrivateRoute = ({ component: Component, slug, superAdminOnly }) => {
    const userData = getLocalKey("admin_user") 
        ? JSON.parse(getLocalKey("admin_user")) : {};
    
    const routes = useSelector(selectRoutes);

    const allowedRoles = [STAFF_ROLE.SUB_ADMIN, STAFF_ROLE.SUPER_ADMIN];
    const isLoggedIn = Object.keys(userData).length && userData.token;
    const hasValidRole = userData?.role && allowedRoles.some(r => userData.role.includes(r));

    if (!isLoggedIn || !hasValidRole) {
        setReturnURL("admin_user");
        return <Navigate to="/admin/login" />;
    }

    const isSuperAdmin = userData?.role?.includes(STAFF_ROLE.SUPER_ADMIN);

    if (superAdminOnly && !isSuperAdmin) {
        return <NoPermission />;
    }

    if (slug && !isSuperAdmin && !routes.includes(slug)) {
        return <NoPermission />;
    }

    return <Component />;
};

export default PrivateRoute;